import type { APIPortal } from "models/types/api-listing";
import { apiClient } from "utils/api-client/index";
import { createModel } from "utils/models";

export const portalsModel = createModel("portals", {
  queries: {
    list: (listingId?: string) => ({
      throwOnError: true,
      meta: {
        showErrorModal: false,
      },
      queryKey: ["list"],
      queryFn: () =>
        apiClient
          .get<{ data: APIPortal[] }>(`/portal/portals?listing_id=${listingId}`)
          .then((r) => r.data),
      keepPreviousData: true,
    }),
  },
});
